import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actions.SEARCH_LOGISTIC_TOOLS:
    case actions.SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE:
    case actions.SEARCH_LOGISTIC_ORDERS:
    case actions.SEARCH_LOGISTIC_ORDER_RECORDS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.SEARCH_LOGISTIC_TOOLS_ENDED:
    case actions.SEARCH_LOGISTIC_CALCULATIVE_METHODS_OF_VEHICLE_ENDED:
    case actions.SEARCH_LOGISTIC_ORDERS_ENDED:
    case actions.SEARCH_LOGISTIC_ORDER_RECORDS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    case actions.CREATE_LOGISTIC_TOOL:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_LOGISTIC_TOOL_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.UPDATE_LOGISTIC_TOOL:
      return {
        ...state,
        isUpdating: true,
      };
    case actions.UPDATE_LOGISTIC_TOOL_ENDED:
      return {
        ...state,
        isUpdating: false,
      };
    default:
      return state;
  }
};
